// src/components/blogs/BlogSearchAndFilters.jsx
import React from 'react'
import { Funnel, Calendar } from 'react-bootstrap-icons'
import { DateRange } from 'react-date-range'

const BlogSearchAndFilters = ({ searchQuery, setSearchQuery, sortBy, setSortBy, calenderDates, changeDataRange }) => {
    return (
        <div className="d-flex px-5">
            <div className="min-w-200px pe-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                />
            </div>
            <div className="dropdown dropdown-inline">
                <button
                    type="button"
                    className="btn btn-sm btn-light-primary"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <Calendar
                        size={18}
                        path="/media/icons/duotune/arrows/arr072.svg"
                        className="svg-icon-2 svg-icon-gray-500"
                    />
                </button>
                <div className="dropdown-menu dropdown-menu-sm dropdown-menu-end">
                    <DateRange
                        editableDateInputs={true}
                        onChange={changeDataRange}
                        moveRangeOnFirstSelection={false}
                        ranges={calenderDates}
                    />
                </div>
            </div>
            &nbsp;
            <div className="dropdown dropdown-inline">
                <button
                    type="button"
                    className="btn btn-sm btn-light-primary"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <Funnel
                        size={18}
                        path="/media/icons/duotune/arrows/arr072.svg"
                        className="svg-icon-2 svg-icon-gray-500"
                    />
                </button>
                <div className="dropdown-menu dropdown-menu-sm dropdown-menu-end">
                    <ul className="navi navi-hover" style={{ listStyle: 'none' }}>
                        <li
                            className={`navi-item mb-2 pt-2 ${sortBy === 1 ? 'text-primary' : ''}`}
                            onClick={() => setSortBy(1)}
                        >
                            <span className="navi-text fw-bold" style={{ cursor: 'pointer' }}>
                                Ascending
                            </span>
                        </li>
                        <li
                            className={`navi-item ${sortBy === -1 ? 'text-primary' : ''}`}
                            onClick={() => setSortBy(-1)}
                        >
                            <span className="navi-text fw-bold" style={{ cursor: 'pointer' }}>
                                Descending
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default BlogSearchAndFilters
